import React, { useEffect, useState, Dispatch } from 'react';
import styled from '@emotion/styled';
import produce from 'immer';
import Names from './Names';
import PropertyForm from './PropertyTab';
import { useOrderEntry } from '../OrderEntryContext';
import AddAdditionalData from './PropertyTab/AddAdditionalData';
import PropertyCard from './PropertyTab/PropertyCard';
import { Property } from '../../types';
import Rpad from './PropertyTab/Rpad';

const OuterStyles = styled.div`
  margin-top: 32px;
  padding: 16px 0 32px 0;
  border-top: 1px solid #e5e5ea;
`;

const PropertiesAndNames = () => {
  const { setProperties, properties, errors } = useOrderEntry();
  const [openForm, setOpenForm] = useState(false);

  return (
    <OuterStyles>
      <div style={{ marginLeft: '15%' }}>
        <div style={{ fontWeight: 600, fontSize: 16, width: 200 }}>Properties</div>
        <div style={{ marginLeft: 200 }}>
          <Rpad />
        </div>
        <div style={{ marginTop: 40 }}>
          <Names />
        </div>
      </div>
    </OuterStyles>
  );
};

export default PropertiesAndNames;
